/**
 * Per-module API base URL factory.
 *
 * Enables module-by-module migration of Tool API traffic to new servers.
 * Each module gets an optional REACT_APP_<MODULE>_API_URL env var; when unset,
 * the module falls back to the app-wide default (REACT_APP_TOOL_API_URL).
 *
 * To migrate a module:
 *   1. Add its key to ApiModule and an entry in MODULE_BASE_URLS
 *      (env vars must be referenced statically — CRA inlines them at build,
 *      so dynamic access like process.env['REACT_APP_' + name] returns undefined).
 *   2. Replace `process.env.REACT_APP_TOOL_API_URL` at the module's call
 *      sites with `getApiBaseUrl(ApiModule.<Module>)`.
 *   3. Add the env var to .env.example (unset = no behavior change).
 */
export enum ApiModule {
  Wysiwyg = 'wysiwyg',
  // Future: DataScenarios, ColorPalette, Audit, Media, Survey, ...
}

const MODULE_BASE_URLS: Record<ApiModule, string | undefined> = {
  [ApiModule.Wysiwyg]: process.env.REACT_APP_WYSIWYG_API_URL,
};

const DEFAULT_BASE_URL = process.env.REACT_APP_TOOL_API_URL;

export function getApiBaseUrl(module: ApiModule): string {
  const url = MODULE_BASE_URLS[module] || DEFAULT_BASE_URL || '';
  return url.replace(/\/+$/, ''); // normalize: strip trailing slash
}
